import { type LogEventAction } from "@north-beam/nb-client-side";
import { type DateInterval } from "@north-beam/nb-common";

import {
  type RecapPerformanceTrackedComponent,
  type CreateCustomBudgetTrackedComponent,
  type ExploreBudgetsTrackedComponent,
  type ModelInsightsTrackedComponent,
  type TrackPerformanceTrackedComponent,
  type TrackedComponent,
  type CreateMediaPlanTrackedComponent,
  type CommonTrackedComponent,
} from "./components";

export enum MMMTab {
  EXPLORE_BUDGETS = "Explore budgets",
  MODEL_INSIGHTS = "Model insights",
  CREATE_CUSTOM_BUDGETS = "Create your own budgets",
  TRACK_PERFORMANCE = "Track Performance",
  RECAP_PERFORMANCE = "Recap Performance",
  CREATE_MEDIA_PLAN = "Create media plan",
  ALL_TABS = "All tabs",
}

export type MMMEvent = {
  tab: MMMTab;
  component: TrackedComponent;
  action: LogEventAction;
  actionInfo?: string;
  data?: Record<string, string>;
};

export type ExploreBudgetsMMMEvent = Omit<MMMEvent, "tab" | "component"> & {
  component: ExploreBudgetsTrackedComponent;
};

export type ModelInsightsMMMEvent = Omit<MMMEvent, "tab" | "component"> & {
  component: ModelInsightsTrackedComponent;
};

export type CreateCustomBudgetMMMEvent = Omit<MMMEvent, "tab" | "component"> & {
  component: CreateCustomBudgetTrackedComponent;
};

export type TrackPerformanceMMMEvent = Omit<MMMEvent, "tab" | "component"> & {
  component: TrackPerformanceTrackedComponent;
};

export type RecapPerformanceMMMEvent = Omit<MMMEvent, "tab" | "component"> & {
  component: RecapPerformanceTrackedComponent;
};

export type CreateMediaPlanMMMEvent = Omit<MMMEvent, "tab" | "component"> & {
  component: CreateMediaPlanTrackedComponent;
};

export type CommonComponentMMMEvent = Omit<MMMEvent, "tab" | "component"> & {
  component: CommonTrackedComponent;
};

export type MMMEventSelectionProperty = {
  selection: string;
};

export function getMMMEventSelectionData(selectionValue?: string) {
  if (selectionValue) {
    return {
      selection: selectionValue,
    };
  }
}
